"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProgressBarStatus = exports.setProgressBarCurrent = exports.setProgressBar = exports.initialState = exports["default"] = void 0;
var _reduxActions = require("redux-actions");
var _handleActions;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var initialState = {
  progressBar: []
};

/* Anatomy of a progressBar object
 * progressBar = [
 *   {
 *     flowData: {
 *       flowHandle_pawnId: status (one of 'not_started', 'started', 'completed')
 *     },
 *     isCurrent: bool,
 *     isMilestone: bool,
 *     status: overallstatus (one of 'not_started', 'started', 'completed')
 *   }
 * ];
 *
 */

// Actions
exports.initialState = initialState;
var SET_PROGRESS_BAR = 'assignment/player/SET_PROGRESS_BAR';
var SET_PROGRESS_BAR_CURRENT = 'assignment/player/SET_PROGRESS_BAR_CURRENT';
var SET_PROGRESS_BAR_STATUS = 'assignment/player/SET_PROGRESS_BAR_STATUS';

// Action Creators
var setProgressBar = (0, _reduxActions.createAction)(SET_PROGRESS_BAR);
exports.setProgressBar = setProgressBar;
var setProgressBarCurrent = (0, _reduxActions.createAction)(SET_PROGRESS_BAR_CURRENT);
exports.setProgressBarCurrent = setProgressBarCurrent;
var setProgressBarStatus = (0, _reduxActions.createAction)(SET_PROGRESS_BAR_STATUS);

// Helper Methods

// Reducers
exports.setProgressBarStatus = setProgressBarStatus;
var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, SET_PROGRESS_BAR, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    progressBar: action.payload
  });
}), _defineProperty(_handleActions, SET_PROGRESS_BAR_CURRENT, function (state, action) {
  var updatedProgressBar = [];
  for (var i = 0; i < state.progressBar.length; i++) {
    var progressObj = state.progressBar[i];
    if (Object.keys(progressObj.flowData).includes(action.payload)) {
      updatedProgressBar.push(Object.assign(progressObj, {
        isCurrent: true
      }));
      continue;
    }
    updatedProgressBar.push(Object.assign(progressObj, {
      isCurrent: false
    }));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    progressBar: updatedProgressBar
  });
}), _defineProperty(_handleActions, SET_PROGRESS_BAR_STATUS, function (state, action) {
  var updatedProgressBar = [];
  var newStatus = action.payload.status;
  for (var i = 0; i < state.progressBar.length; i++) {
    var progressObj = Object.assign({}, state.progressBar[i]);
    var flowHandles = Object.keys(progressObj.flowData);
    if (!flowHandles.includes(action.payload.handle)) {
      updatedProgressBar.push(progressObj);
      continue;
    }
    // Must determine if overall status should change
    var allCompleted = true;
    for (var j = 0; j < flowHandles.length; j++) {
      // We can't move backwards from 'completed'
      if (progressObj.flowData[flowHandles[j]] === 'completed') {
        continue;
      }
      if (flowHandles[j] === action.payload.handle) {
        progressObj.flowData[flowHandles[j]] = newStatus;
        if (newStatus === 'completed') {
          continue;
        }
      }
      allCompleted = false;
    }
    progressObj.status = allCompleted ? 'completed' : 'started';
    updatedProgressBar.push(progressObj);
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    progressBar: updatedProgressBar
  });
}), _handleActions), initialState);
exports["default"] = _default;